export default class RuntimeError {
  constructor(message, code = 1000, type = 'error') {
    this._message = message
    this._code = code
    this._type = type
  }

  get message() {
    return this._message
  }

  set message(value) {
    this._message = value
  }

  get code() {
    return this._code
  }

  set code(value) {
    this._code = value
  }

  get type() {
    return this._type
  }

  set type(value) {
    this._type = value
  }
}
